import { z } from 'zod'
import type { LandingPageVersionDocument } from '@fa/pod-schema'

// The Active Store configuration's pinned Landing Page Version (Hapi ADR
// daniel-0033), and the public-slug version (sc-7841), which shares the envelope.
// Checks `marketCodes` and the section fields listed below; anything
// else that throws is caught by the index's boundary. Each type's `config` is trusted: Hapi validates it at write
// time (Frontend ADR 0003). A schema-version bump that reshapes these fields must
// loosen this too (Frontend ADR daniel-0007 decision 2). The document envelope is
// shared with the Campaign page, which parses `assignment.document` with it (sc-7845).
const sectionSchema = z
  .object({
    sectionType: z.string(),
    config: z.record(z.string(), z.unknown()),
    sortOrder: z.number(),
    visible: z.boolean().optional(),
    assets: z.array(z.object({ role: z.string(), sortOrder: z.number() }).passthrough()),
    bgColorHex: z.string().nullable().optional(),
    marginTopPx: z.number().nullable().optional(),
    marginBottomPx: z.number().nullable().optional(),
  })
  .passthrough()

export const pinnedDocumentSchema = z
  .object({
    sections: z.array(sectionSchema),
    marketCodes: z.array(z.string()).optional(),
  })
  .passthrough()

export const storeLandingPageSchema = z.object({
  versionId: z.number().int(),
  schemaVersion: z.number().int(),
  document: pinnedDocumentSchema,
})

export type StoreLandingPage = {
  versionId: number
  schemaVersion: number
  document: LandingPageVersionDocument
}
